/** PLAME: bonificación por turno nocturno */
export const CODIGO_PLAME_BONIFICACION_NOCTURNA = '0309';

export const PREFIJO_LOG_DIAGNOSTICO_0309 = '🌙[DIAG-0309]';

/**
 * Log estructurado para depurar 0309 / tasa nocturna (filtrar consola por DIAG-0309).
 */
export function logDiagnosticoBonificacionNocturna(etapa, payload = {}) {
  console.groupCollapsed(`${PREFIJO_LOG_DIAGNOSTICO_0309} ${etapa}`);
  console.log(payload);
  console.groupEnd();
}

/** Línea visible (no colapsada) para depuración rápida en consola. */
export function logDiagnosticoBonificacionNocturnaVisible(mensaje, payload = {}) {
  console.warn(`${PREFIJO_LOG_DIAGNOSTICO_0309} ${mensaje}`, payload);
}

/**
 * Tasa nocturna activa y calculada en planilla → el 0309 se obtiene de tareos, no de concepto estático.
 */
export function tasaNocturnaPriorizaSobreConceptoEstatico(tasaNocturna) {
  return Boolean(tasaNocturna?.activo && tasaNocturna?.calcularEnPlanilla !== false);
}

export function esCodigoBonificacionNocturna(codigoPlame) {
  return String(codigoPlame || '') === CODIGO_PLAME_BONIFICACION_NOCTURNA;
}

/** Omitir 0309 del bucle plantilla/tareos cuando la tasa nocturna en planilla tiene prioridad. */
export function debeOmitir0309EnProcesamientoPlantilla(codigoPlame, tasaNocturna) {
  return (
    tasaNocturnaPriorizaSobreConceptoEstatico(tasaNocturna) &&
    esCodigoBonificacionNocturna(codigoPlame)
  );
}

/**
 * 0309 en conceptos estáticos + tasa nocturna desactivada → monto íntegro de plantilla,
 * sin prorrateo por mes parcial (historial laboral).
 */
export function debeUsarMontoEstaticoCompleto0309(codigoPlame, esConceptoEstatico, tasaNocturnaPrioriza) {
  return (
    Boolean(esConceptoEstatico) &&
    esCodigoBonificacionNocturna(codigoPlame) &&
    !tasaNocturnaPrioriza
  );
}

/** No sumar 0309 desde tareos si ya se resuelve por concepto estático en plantilla. */
export function debeOmitir0309DeTareos(codigoPlame, esConceptoEstatico, tasaNocturna) {
  return debeUsarMontoEstaticoCompleto0309(
    codigoPlame,
    esConceptoEstatico,
    tasaNocturnaPriorizaSobreConceptoEstatico(tasaNocturna)
  );
}
